export function buildWorkspaceMembershipListQuery() {
    return {
        fields: ["isDefault", "memberShipStatus", "workspaceConfigs"],
        populate: {
            workspace: true,
        },
        pagination: {
            pageSize: 100,
            withCount: false,
        },
    };
}

export function buildActiveWorkspaceContextQuery(userId) {
    return {
        populate: {
            member: {populate: ["profileImage"]},
            user_roles: {
                fields: ["role", "scope_id", "scope_type", "permissions"],
            },
            workspace: {
                populate: {
                    workspace_memberships: {
                        populate: {
                            user_roles: {
                                fields: ["role", "scope_id", "scope_type"],
                            },
                            member: {
                                populate: ["profileImage"],
                            },
                        },
                    },
                },
            },
        },
    };
}
